import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(
  () => ({
    svgContainerParent: () => ({}),
  }),
  { index: 1 }
);
export default useStyles;
